<template>
    <div id="copyright" class="copyright">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="copyright-info text-center text-lg-left">
                        <span>Copyright © 2013-{{ new Date() | year }} Szekelyfold.ma Minden jog fenntartva. Powered by <a href="https://dworldsoftware.com" class="text-white">DWS</a></span>
                    </div>
                </div>

                <div class="col-sm-12 col-md-6">
                    <div class="footer-menu">
                        <ul class="row nav unstyled justify-content-center">
                            <li><a href="/impresszum">Impresszum</a></li>
                            <li><a href="/jogi-nyilatkozat">Jogi nyilatkozat</a></li>
                            <li><a href="/sutik">Sütik (Cookies)</a></li>
                            <li><a href="https://play.google.com/store/apps/details?id=ma.szekelyfold.dws.com.szekelyfoldma">Android verzió</a></li>
                            <li><a href="/kapcsolat">Kapcsolat</a></li>
                        </ul>
                    </div>
                </div>
            </div><!-- Row end -->

            <div id="back-to-top" class="back-to-top" style="">
                <button class="btn btn-primary" title="Back to Top" @click="scrollToTop">
                    <i class="fa fa-angle-up"></i>
                </button>
            </div>

        </div><!-- Container end -->
    </div>
</template>

<script>
    export default {
        name: 'Copyright',
        methods: {
            scrollToTop() {
                window.scrollTo({
                    top:0,
                    left: 0,
                    behavior: 'smooth'
                })
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/absctracts/variables.scss';

    #copyright {
        background: $red;
        color: $white;
        padding: 15px 0;
        position: relative;
        z-index: 1;
        font-weight: 500;
        font-size: 13px;

        .copyright-info{
            a:hover {
                text-decoration: underline;
            }
        }

        .footer-menu {
            float: right;

            ul li {
                display: inline-block;
                line-height: 20px;
                padding-left: 12px;

                a {
                    background: none;
                    color: #fff;
                    padding: 0;
                }

                a:hover {
                    text-decoration: underline;
                }
            }

            .unstyled {
                list-style: none;
                margin: 0;
                padding: 0;
            }
        }

        .back-to-top {
            position: fixed;
            right: 55px;
            bottom: 54px;
            z-index: 10;
            -webkit-backface-visibility: hidden;

            .btn.btn-primary {
                width: 30px;
                height: 30px;
                line-height: 30px;
                background: rgba(0, 0, 0, 0.9);
                border-color: $white;
                font-weight: 700;
                font-size: 16px;
                padding: 0;
            }

            .btn.btn-primary:hover {
                background-color: $red;
            }
        }
    }
</style>